<template lang="pug">
el-breadcrumb(separator="/")
  el-breadcrumb-item(v-for="{ label, name, to, id } in navArr", :class="{ active: id === currentName }", :key="id", :to="to")
    span.breadcrumb-label {{ label }}
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      flatRoutes: "flatRoutes"
    }),
    navArr() {
      const {
        flatRoutes,
        $route: { name }
      } = this;
      const paths = [];
      let list = [];
      // 从模块数据直接获取父子关系和对应数据
      let model = flatRoutes.find(({ permissionKey }) => name === permissionKey);
      // 如果当前模块在应用下,额外添加一层 应用分组
      let appGroupLayer;
      if (model) {
        while (model) {
          paths.push(model);
          const name = model.permissionKey;
          list.unshift({ id: name, name, label: model.permissionName, to: { name }});
          if (model.appCode) appGroupLayer = { id: app.appCode, name, label: model.appName, to: { name: "applicationAll", query: { appCode: model.appCode }}};
          const pid = model.pid;
          model = flatRoutes.find(({ permissionId }) => permissionId === pid);
        }
        if (appGroupLayer) list.splice(1, 0, appGroupLayer);
      } else {
        list = this.$route.matched.slice(1).map(({ meta, name }) => ({ label: meta.routeName, id: name, to: { name }, name }));
      }
      return list;
    },
    currentName() {
      return this.$route.name;
    }
  }
};
</script>
<style scoped lang="scss">
.breadcrumb-label {
  font-size: 14px;
  color: #909399;
  .active & {
    color: #303133;
    font-weight: 700;
  }
}
.el-breadcrumb {
  /deep/ .el-breadcrumb__separator {
    font-size: 15px !important;
  }
}
</style>
